import React, { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { Provider } from "react-redux";
import AppRouter from "./AppRouter";

import store from "./store";

import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { QueryClient, QueryClientProvider } from "react-query";
import ReactGA from "react-ga";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import i18n from "./langs";
import "react-day-picker/dist/style.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});


Sentry.init({
  dsn: "https://ac7b6e49a33e47af8e1bcfd4b2d1d044@o854569.ingest.sentry.io/5819694",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.1,
});

const isAirekey = document.URL.indexOf("airekey") >= 0;

const TRACKING_ID = isAirekey ? "UA-78083318-1" : "G-NN9H7442E6'";
ReactGA.initialize(TRACKING_ID);

const appFavicon = isAirekey ? "airekey_favicon.png" : "favicon.png";

let oldFavicon = document.getElementById("favicon");
var link = document.createElement("link");
link.id = "favicon";
link.type = "image/x-icon";
link.rel = "icon";
link.href = appFavicon + "?=" + Math.random();
if (oldFavicon) {
  document.head.removeChild(oldFavicon);
}
document.head.appendChild(link);

document.title = isAirekey
  ? "COVID-19! Contactless online Check in for booking hotel, vacation rental, airbnb & short term rentals, airEkey Keyless System"
  : "Vikey";



function App() {
  useEffect(() => {
    window.Intercom("shutdown");
    window.Intercom("boot", {
      app_id: "ux6abiod",
    });
    window.Intercom("update", {
      hide_default_launcher: true,
      language_override: i18n.language,
    });
  }, []);

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <AppRouter></AppRouter>
        <ToastContainer
          style={{
            borderRadius: "4px",
          }}
          transition={Slide}
        ></ToastContainer>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
